import {
    SHOW_POPUP,
    HIDE_POPUP,
    SHOW_USER_POPUP,
    HIDE_USER_POPUP,
    SHOW_FORGOT,
    HIDE_FORGOT,
    SHOW_SET_PASSWORD,
    HIDE_SET_PASSWORD,
    SHOW_LOGIN,
    HIDE_LOGIN,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    SHOW_CONTEXT,
    HIDE_CONTEXT,
    SET_PASSWORD_REQUEST,
    SET_PASSWORD_SUCCESS,
    SET_PASSWORD_FAIL,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    SHOW_SAVE_VIEW,
    HIDE_SAVE_VIEW,
    COUNTRIES_SUCCESS,
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    SAVE_NEW_REVISION,
    STORE_FREIGHTS,
    REFRESH_COMPANY_ID,
} from '../constants/action-types';

const initialState = {
  isPopupVisible: false,
  isForgotPopupVisible: false,
  isLoginVisible: false,
  isUserPopupVisible: false,
  userPopupCompanyId: '',
  isLoading: false,
  showProgress: false,
  isSetPasswordVisible: false,
  isSaveViewPopupVisible: false,
  isSessionExpired: false, 
  isPasswordReset: false, 
  countries: [],
  popupProps: {},
  serverRevision: false,
  context: {
      visible: false,
      x: 0,
      y: 0
  },
  freights: [],
}

export default function app(state = initialState, action) {
    
    switch (action.type) {
        case SHOW_POPUP:
            return {
                ...state,
                isPopupVisible: true,
                popupProps: action.popupProps
            }
        case HIDE_POPUP:
            return {
                ...state,
                isPopupVisible: false,
                popupProps: {}
            }
        case SHOW_USER_POPUP:
            return {
                ...state,
                isUserPopupVisible: true,
                userPopupCompanyId: action.companyId || '',
            }
        case HIDE_USER_POPUP:
            return {
                ...state,
                isUserPopupVisible: false,
                userPopupCompanyId: ''
            }
        case SHOW_LOGIN:
            return {
                ...state,
                isLoginVisible: true,
                isSessionExpired: action.isExpired
            }
        case HIDE_LOGIN:
            return {
                ...state,
                isLoginVisible: false,
                isSessionExpired: false,
                isPasswordReset: false
            }
        case SHOW_FORGOT:
            return {
                ...state,
                isForgotPopupVisible: true,
                isLoginVisible: false,
            }
        case HIDE_FORGOT:
            return {
                ...state,
                isForgotPopupVisible: false,
            }
        case SHOW_SET_PASSWORD:
            return {
                ...state,
                isSetPasswordVisible: true,
            }
        case HIDE_SET_PASSWORD:
            return {
                ...state,
                isSetPasswordVisible: false,
            }
        case SHOW_SAVE_VIEW:
            return {
                ...state,
                isSaveViewPopupVisible: true,
            }
        case HIDE_SAVE_VIEW:
            return {
                ...state,
                isSaveViewPopupVisible: false,
            }
        case SHOW_PROGRESS:
            return {
                ...state,
                showProgress: true,
            }
        case HIDE_PROGRESS:
            return {
                ...state,
                showProgress: false,
            }
        case SHOW_CONTEXT:
            return {
                ...state,
                context: {
                    visible: true,
                    x: action.x,
                    y: action.y,
                    params: action.params
                }
            }
        case HIDE_CONTEXT:
            return {
                ...state,
                context: {
                    visible: false,
                }
            }
        case SET_PASSWORD_SUCCESS:
            return {
                ...state,
                isPasswordReset: true,
                showProgress: false,
            }
        case RESET_PASSWORD_REQUEST:
        case SET_PASSWORD_REQUEST:
        case SIGNUP_REQUEST:
            return {
                ...state,
                showProgress: true,
            }
        case RESET_PASSWORD_SUCCESS:            
        case RESET_PASSWORD_FAIL:        
        case SET_PASSWORD_FAIL:
        case SIGNUP_SUCCESS:
        case SIGNUP_FAIL:
            return {
                ...state,
                showProgress: false,
            }
        case COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.payload
            }
        case SAVE_NEW_REVISION:
            return {
                ...state,
                serverRevision: action.data
            }
        case STORE_FREIGHTS:
            return {
                ...state,
                freights: action.payload,
            }
        case REFRESH_COMPANY_ID:
                return {
                    ...state,
                    userPopupCompanyId: -1
                }
        default:
            return state;
  }

}



// WEBPACK FOOTER //
// ./source/reducers/app.js